import React, { useEffect, useState } from "react";
import url from "../../url.json";
import headers from "../../config/headers";
import { toast } from "react-toastify";
import { withTranslation } from "react-i18next";
import axios from "axios";
import { Skeleton } from "antd";
import { Helmet } from "react-helmet-async";

// Profil faqat ko'rish uchun: tashkilot ma'lumotlari ERI yoki moderator orqali o'zgaradi
const Field = ({ label, value, wide }) => (
  <div className={wide ? "ap-field ap-field--wide" : "ap-field"}>
    <dt>{label}</dt>
    <dd>{value || <span className="ap-muted">—</span>}</dd>
  </div>
);

function Profile({ t }) {
  const [datas, setDatas] = useState();

  useEffect(() => {
    axios.defaults.headers.common[
      "Authorization"
    ] = `Bearer ${localStorage.getItem("token")}`;
    axios
      .get(url.url + "/legal-entity/profile", { headers: headers() })
      .then((res) => setDatas(res.data.data))
      .catch((err) => {
        if (err.response?.status == 401) {
          window.location = "/";
          localStorage.removeItem("token");
          localStorage.removeItem("user");
        }
        if (err.response?.status == 404) window.location = "/404";
        if (err.response?.status == 405) toast.error(err.response.data.error);
      });
  }, []);

  if (!datas)
    return (
      <div className="pf-card">
        <Skeleton avatar paragraph={{ rows: 6 }} active />
      </div>
    );

  const legal = datas.legal_entity;
  const verif = !legal
    ? null
    : legal.blocked_at
    ? { cls: "is-blocked", label: "ln_status_blocked", hint: "blog_info", icon: "bxs-x-circle" }
    : legal.verified_at
    ? { cls: "is-verified", label: "ln_status_verified", hint: "success_info", icon: "bxs-check-circle" }
    : { cls: "is-pending", label: "ln_status_pending", hint: "warning_info", icon: "bxs-time" };

  return (
    <div className="pf">
      <Helmet>
        <meta charSet="utf-8" />
        <title>Vis Nefrit | {t("Profile")}</title>
      </Helmet>

      <section className="pf-head">
        <div className="pf-avatar">
          <span>{(legal?.name || datas.username || "?").charAt(0)}</span>
        </div>
        <div className="pf-head__info">
          <span className="ln-eyebrow">{t("ln_cab_group_account")}</span>
          <h1>{legal?.name || datas.username}</h1>
          <div className="pf-head__meta">
            <span><i className="bx bx-user" />{datas.username}</span>
            {datas.email ? <span><i className="bx bx-envelope" />{datas.email}</span> : ""}
            {legal?.inn ? <span><i className="bx bx-id-card" />{t("Inn")}: {legal.inn}</span> : ""}
          </div>
          {verif ? (
            <span className={`ln-side__status ${verif.cls}`} title={t(verif.hint)}>
              <i className={`bx ${verif.icon}`} />
              {t(verif.label)}
            </span>
          ) : (
            ""
          )}
        </div>
      </section>

      <section className="pf-card">
        <h3 className="pf-card__title"><i className="bx bx-buildings" />{t("ln_profile_company")}</h3>
        <dl className="ap-grid">
          <Field label={t("Name")} value={legal?.name} wide />
          <Field label={t("Inn")} value={legal?.inn} />
          <Field label={t("Boss name")} value={legal?.boss_name} />
          <Field label={t("Country")} value={legal?.country?.name} />
          <Field label={t("Phone")} value={legal?.phone} />
          <Field label={t("Address")} value={legal?.address} wide />
          <Field label={t("Website")} value={legal?.website} />
          <Field label={t("Fax address")} value={legal?.fax} />
        </dl>
      </section>

      <section className="pf-card">
        <h3 className="pf-card__title"><i className="bx bx-user-circle" />{t("ln_profile_account")}</h3>
        <dl className="ap-grid">
          <Field label={t("Username")} value={datas.username} />
          <Field label={t("Email")} value={datas.email} />
        </dl>
      </section>

      <div className="ln-notice pf-notice">
        <i className="bx bx-info-circle" />
        <div>
          <strong>{t("ln_profile_locked_title")}</strong>
          <p>{t("ln_cab_profile_text")}</p>
        </div>
      </div>
    </div>
  );
}
export default withTranslation()(Profile);
